/** Build-time configuration injected by Vite. */
export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string) || 'http://localhost:3001',
  supportUrl:
    (import.meta.env.VITE_SUPPORT_URL as string) || 'http://localhost:4200',
};
